// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as SendSmsPayload from "../api-model/SendSmsPayload.bs.js";
import * as Network$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ResendSmsPayload from "../api-model/ResendSmsPayload.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as SendSmsRepoConfig from "./SendSmsRepoConfig.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as CreateSmsTemplatePayload from "../api-model/CreateSmsTemplatePayload.bs.js";
import * as DeleteSmsTemplatePayload from "../api-model/DeleteSmsTemplatePayload.bs.js";

function fetchSMSUser(param, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/fetch_customer_partner_details?query=" + param.query + "&query_type=" + param.query_type);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SMSUserResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchSMSList(param, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/get_sms_details_v2?phone_number=" + param.phone_number + "&limit=" + String(param.limit) + "&pagination_token=" + param.pagination_token);
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SmsMessageResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchSMSTemplateList(country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/fetch_active_templates";
  return NetworkUtils.catchPromiseError(NetworkV2$Catalyst.get(requestUrl, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined, /* Include */2, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SMSTemplateListResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function sendSMSMessage(param, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/send_sms";
  var payload = JSON.stringify(SendSmsPayload.t_encode(param));
  return NetworkUtils.catchPromiseError(Network$Catalyst.postRequestV2(requestUrl, payload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SmsSendMessageResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function resendSMSMessage(param, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/resend_sms";
  var payload = JSON.stringify(ResendSmsPayload.t_encode(param));
  return NetworkUtils.catchPromiseError(Network$Catalyst.postRequestV2(requestUrl, payload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SmsSendMessageResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function createSMSTemplate(param, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/sms_template/create_template";
  var payload = JSON.stringify(CreateSmsTemplatePayload.t_encode(param));
  return NetworkUtils.catchPromiseError(Network$Catalyst.postRequestV2(requestUrl, payload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.EditSmsTemplateResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function deleteSMSTemplate(param, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/sms_template/delete_template";
  var payload = JSON.stringify(DeleteSmsTemplatePayload.t_encode(param));
  return NetworkUtils.catchPromiseError(Network$Catalyst.postRequestV2(requestUrl, payload, {
                    country: CountryConfig.countryToString(country)
                  }, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.EditSmsTemplateResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var SendSmsRepo = {
  fetchSMSUser: fetchSMSUser,
  fetchSMSList: fetchSMSList,
  fetchSMSTemplateList: fetchSMSTemplateList,
  sendSMSMessage: sendSMSMessage,
  resendSMSMessage: resendSMSMessage,
  createSMSTemplate: createSMSTemplate,
  deleteSMSTemplate: deleteSMSTemplate
};

export {
  SendSmsRepo ,
  
}
/* Config Not a pure module */
